import { convertirBase64, notify, quitarTildes } from "../../utils/utils"


export const useNotificaciones = () => {

    const obtenerToken = async () => {
        const urlAuntenticacion = 'https://identityserver-service.abexa.pe/oauth2/token'
        try{
            const response = await fetch(urlAuntenticacion,{
                method: 'POST',
                body: new URLSearchParams({
                    grant_type:'password',
                    username:'hcerna',
                    password:'123456',
                    scope:'openid profile generic-notifier.read generic-notifier.write',

                }).toString(),
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Basic U1RmMGxtdWxVSFJQMVhMc0RDZTdiZjM2eDhrYTpCZXJyc1ZsZEdUWHRnWFRpc2g5bjRZdDFSaDhh'
                }
            }).then(res => res.json())
            if(response.access_token){
                console.log('Entro al token')
                return{
                    isValid: true,
                    token: response.access_token
                };
            }
            else{
                return{ isValid: false};
            }
        }
        catch(e){
            console.log('Error al obtener el token: ',e)
            notify('Ocurrió un error en el servicio','error')
            return{ isValid: false}
        }
    }
    const notificacionPorArea = async (token, area, mensaje, proyecto) => {
        const datosEnBase64 = await convertirBase64({project:  proyecto || 'PGI', nomarea: quitarTildes(area.replaceAll(' ','').toUpperCase())})
        const urlNotificacion = 'https://genericnotifierwebapi-prod.abexacloud.com/context/api/notifier'
        try{
            const body = {
                "cmd": "NOTIFICACION_INCIDENCIA_AREA",
                "commandType": "FIRE_AND_FORGET",
                "messageType": "ABROK_JSON",
                "clientType": "PROJECT",
                "id": datosEnBase64,
                "payload": {
                    "mensaje": mensaje,
                }
            }
            const headers = new Headers();
            headers.append("Content-Type", "application/json");
            headers.append("Authorization", "Bearer " + token);
            const response = await fetch(urlNotificacion, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: headers,
                redirect: "follow",
                // mode:'no-cors'
            })
            .then(res => res)
            .catch(e => console.log('Error ',e))
            // !response.isValid && notify(response.exceptions[0].description, 'error');
            console.log('response ',response)
            // return response.isValid;
        }
        catch(e){
            notify('Ocurrió un error en el servicio ','error');
            console.log('Error al enviar notificación: ',e);
        }
    }

    return{
        obtenerToken,
        notificacionPorArea
    }
}